/**
 * Tenant file create (presigned upload flow).
 * Thin wrapper around the host `apiClient` (same style as `apps/workspaces/src/services`).
 *
 * @param {import('axios').AxiosInstance} apiClient - Axios instance from {@link @aimsos/api-client#createApiClient} (response interceptor returns body only).
 * @param {object} body - Request body for POST /v1/tenant/file/create
 * @param {import('axios').AxiosRequestConfig} [requestConfig] — e.g. `{ timeout: 120_000 }` for presigned URL prep
 * @returns {Promise<object>} Parsed API body (same shape legacy received as `response.data`)
 */
export const createTenantFile = async (apiClient, body, requestConfig = {}) => {
  return apiClient.post('/v1/tenant/file/create', body, requestConfig);
};
